import React, { Component } from "react";
import "./App.css";
import MilesCalculator from "./MilesCalculator.js";
import TotalMilesCalculator from "./TotalMilesCalculator.js";

class App extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      prices: {
        base: "",
        af: "",
        hertz: "",
        rad: ""
      }
    };
  }

  handleChange(e) {
    let priceIndex = e.target.name;
    let priceValue = e.target.value;

    this.setState(function(prev, props) {
      let prices = prev.prices;
      prices[priceIndex] = priceValue;
      console.log(prices);
      return {
        prices: prices
      };
    });
  }

  render() {
    const prices = this.state.prices;
    return (
      <div className="App">
        <table>
          <tbody>
            <tr>
              <th>Dépenses annuelles</th>
              <th>En Euro</th>
            </tr>
            <tr>
              <th className="inner">Achat courant</th>
              <td>
                <input
                  value={prices.base}
                  name="base"
                  type="number"
                  onChange={this.handleChange}
                />
              </td>
            </tr>
            <tr>
              <th className="inner">Achat chez Air France et KLM</th>
              <td>
                <input
                  value={prices.af}
                  name="af"
                  type="number"
                  onChange={this.handleChange}
                />
              </td>
            </tr>
            <tr>
              <th className="inner">Achat chez Hertz</th>
              <td>
                <input
                  value={prices.hertz}
                  name="hertz"
                  type="number"
                  onChange={this.handleChange}
                />
              </td>
            </tr>
            <tr>
              <th className="inner">
                Achat chez Radisson Blu Hotels &amp; Resorts et Printemps
              </th>
              <td>
                <input
                  value={prices.rad}
                  name="rad"
                  type="number"
                  onChange={this.handleChange}
                />
              </td>
            </tr>
            <tr>
              <td />
              <td />
            </tr>
            <tr>
              <th>Silver</th>
              <th>Gains de Miles</th>
            </tr>
            <tr>
              <th className="inner">Achat courant</th>
              <td>
                <MilesCalculator multiplier="0.8" price={prices.base} />
              </td>
            </tr>
            <tr>
              <th className="inner">Achat chez Air France et KLM</th>
              <td>
                <MilesCalculator multiplier="1" price={prices.af} />
              </td>
            </tr>
            <tr>
              <th className="inner">Achat chez Hertz</th>
              <td>
                <MilesCalculator multiplier="1" price={prices.hertz} />
              </td>
            </tr>
            <tr>
              <th className="inner">
                Achat chez Radisson Blu Hotels &amp; Resorts et Printemps
              </th>
              <td>
                <MilesCalculator multiplier="0.8" price={prices.rad} />
              </td>
            </tr>
            <tr>
              <td />
              <td />
            </tr>
            <tr>
              <th className="inner">
                Bonus de bienvenue avec lien de parrainage (Habituellement
                4000)*
              </th>
              <td>
                <div className="CellDisplay">6000</div>
              </td>
            </tr>
            <tr>
              <th className="inner">Total de Miles la première année</th>
              <td>
                <TotalMilesCalculator
                  prices={prices}
                  multipliers={[0.8, 1, 1, 0.8]}
                  bonus="6000"
                />
              </td>
            </tr>
            <tr>
              <td />
              <td />
            </tr>
            <tr>
              <th>Gold</th>
              <th>Gains de Miles</th>
            </tr>
            <tr>
              <th className="inner">Achat courant</th>
              <td>
                <MilesCalculator multiplier="1" price={prices.base} />
              </td>
            </tr>
            <tr>
              <th className="inner">Achat chez Air France et KLM</th>
              <td>
                <MilesCalculator multiplier="1.5" price={prices.af} />
              </td>
            </tr>
            <tr>
              <th className="inner">Achat chez Hertz</th>
              <td>
                <MilesCalculator multiplier="1.5" price={prices.hertz} />
              </td>
            </tr>
            <tr>
              <th className="inner">
                Achat chez Radisson Blu Hotels &amp; Resorts et Printemps
              </th>
              <td>
                <MilesCalculator multiplier="1.5" price={prices.rad} />
              </td>
            </tr>
            <tr>
              <td />
              <td />
            </tr>
            <tr>
              <th className="inner">
                Bonus de bienvenue avec lien de parrainage (Habituellement
                6000)*
              </th>
              <td>
                <div className="CellDisplay">8000</div>
              </td>
            </tr>
            <tr>
              <th className="inner">Total de Miles la première année</th>
              <td>
                <TotalMilesCalculator
                  prices={prices}
                  multipliers={[1, 1.5, 1.5, 1.5]}
                  bonus="8000"
                />
              </td>
            </tr>
            <tr>
              <td />
              <td />
            </tr>
            <tr>
              <th>Platinum</th>
              <th>Gains de Miles</th>
            </tr>
            <tr>
              <th className="inner">Achat courant</th>
              <td>
                <MilesCalculator multiplier="1.5" price={prices.base} />
              </td>
            </tr>
            <tr>
              <th className="inner">Achat chez Air France et KLM</th>
              <td>
                <MilesCalculator multiplier="2" price={prices.af} />
              </td>
            </tr>
            <tr>
              <th className="inner">Achat chez Hertz</th>
              <td>
                <MilesCalculator multiplier="2" price={prices.hertz} />
              </td>
            </tr>
            <tr>
              <th className="inner">
                Achat chez Radisson Blu Hotels &amp; Resorts et Printemps
              </th>
              <td>
                <MilesCalculator multiplier="2" price={prices.rad} />
              </td>
            </tr>
            <tr>
              <td />
              <td />
            </tr>
            <tr>
              <th className="inner">
                Bonus de bienvenue avec lien de parrainage (Habituellement
                20000)*
              </th>
              <td>
                <div className="CellDisplay">30000</div>
              </td>
            </tr>
            <tr>
              <th className="inner">Total de Miles la première année</th>
              <td>
                <TotalMilesCalculator
                  prices={prices}
                  multipliers={[1.5, 2, 2, 2]}
                  bonus="30000"
                />
              </td>
            </tr>
            <tr>
              <td />
              <td />
            </tr>
            <tr>
              <td>
                *Voir offre sur le site American Express, les offres pouvant
                changer sans préavis
              </td>
              <td />
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js